import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';
import Mgr from '@/utils/SecurityService';

var isDevEnv = process.env.NODE_ENV == "development";
var url = config.SIGNALR_END_POINT;

let mgr = new Mgr();
let connection = new HubConnectionBuilder()
    .withUrl(url/*, { transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling }*/)
    .build();

connection.on("onForceLogout", message => {
    alert(message);
    mgr.signOut();
});

export default connection;